import CardSystem from '../CardSystem';
import GameObject from '../../../GameObject/GameObject';
import { PlaySound } from '../../Audio/AudioHelper';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import Animator from '../../../Prototype/Animator';
import { UIEvent } from '../../UI/BaseUISystem';
import SpriteComponent from '../../../Component/Render/Sprite';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import BaseCard from 'Prototype/Level/Card/BaseCard';
import { IShuffleBoosterTargetData } from 'State/Card/BoosterBehavior/ShuffleBoosterBehavior';
export type ShuffleTargetData = IShuffleBoosterTargetData & { card: BaseCard };

export default function ShuffleCardAnimation(system: CardSystem, taskData: ICardStateTaskData): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);
    PlaySound('shuffle');
    const targets = taskData.targets.map((target: IShuffleBoosterTargetData) => {
        const card = system.getCardByID(target.cardID);
        card.getChildByName(BaseCard.CARD_FRONT_NAME).getComponent(SpriteComponent).texture = `card${target.oldValue +
            1}`;

        return {
            ...target,
            card,
        };
    });

    const shuffleAnimator = GameObject.Instantiate(Animator);
    system.animator.addChild(shuffleAnimator);

    system.taskQueue.queue(
        new CardAnimationTask(taskData, system, 'BoosterShuffle', shuffleAnimator, {
            targets: targets,
        })
    );
}
